import { Component, Input } from "@angular/core";
import { CoreMenuItem } from "src/app/menu/core-menu";

@Component({
    selector: "app-side-menu-item",
    templateUrl: "./menu-item.component.html",
    styleUrl: "./menu-item.component.scss",
    standalone: false
})
export class SideMenuItemComponent {
  @Input() menu: CoreMenuItem;
}
